import axios from "../utils/axios.js";

export const getKeywords = async (jobTitles) => {
    try {
        const keywordsObject = await axios.post("/api/skills", {
          job_titles: jobTitles,
        });

        return keywordsObject?.data;
    } catch (err) {
        return {};
    }
};
